import Vue from 'vue'
import VueRouter from 'vue-router'
import { Toast } from 'vant'
import userRoute from './modules/user'
import EquipmentRoute from './modules/Equipment'
import Purchases from './modules/Purchase'
import Login from './modules/Login'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/QueryRecharge',
    name: 'QueryRecharge',
    component: () => import(/* webpackChunkName: "login" */ '../views/QueryRecharge/index.vue'),
    meta: { title: '卡号查询' }
  },
  {
    path: '/rechargeFlowAdd',
    name: 'rechargeFlowAdd',
    component: () => import(/* webpackChunkName: "login" */ '../views/Recharge/flowadd.vue'),
    meta: { title: '流量包充值' }
  },
  {
    path: '/packageAdd',
    name: 'packageAdd',
    component: () => import(/* webpackChunkName: "login" */ '../views/Recharge/packageAdd.vue'),
    meta: { title: '流量充值' }
  },
  {
    path: '/rechargeQryindex/:iccid',
    name: 'QueryRechargeV2',
    component: () => import(/* webpackChunkName: "about" */ '../views/QueryRecharge/index.vue'),
    meta: { title: '卡号查询V2' }
  },
  {
    path: '/',
    redirect: '/QueryRecharge'
  },
  {
    path: '/Close',
    name: 'Close',
    component: () => import(/* webpackChunkName: "login" */ '../views/Close.vue'),
    meta: { title: ' ' }
  },
  {
    path: '/Pay',
    name: 'Pay',
    component: () => import(/* webpackChunkName: "about" */ '../views/pay.vue'),
    meta: { title: ' ' }
  },
  {
    path: '/Recharge/:iccid',
    name: 'Recharge',
    component: () => import(/* webpackChunkName: "about" */ '../views/Recharge/index.vue'),
    meta: { title: '卡号信息' }
  },
  {
    path: '/Mobile/Recharge/:iccid',
    name: 'MobileRecharge',
    component: () => import(/* webpackChunkName: "about" */ '../views/loading.vue'),
    meta: { title: '卡号信息' }
  },
  ...userRoute,
  ...EquipmentRoute,
  ...Purchases,
  ...Login,
  {
    path: '/index',
    component: () => import(/* webpackChunkName: "content" */ '../views/Index/index.vue'),
    redirect: '/Home',
    meta: { title: '首页' },
    children: [
      { path: '/Home', name: 'Home', component: () => import(/* webpackChunkName: "content" */ '../views/Index/modules/Home.vue'), meta: { title: '首页', keepAlive: true } },
      { path: '/Equipment/:id', name: 'Equipment', component: () => import(/* webpackChunkName: "content" */ '../views/Index/modules/Equipment.vue'), meta: { title: '设备', keepAlive: false } },
      { path: '/EquipmentBeyond', name: 'EquipmentBeyond', component: () => import(/* webpackChunkName: "content" */ '../views/Index/modules/EquipmentBeyond.vue'), meta: { title: '超流量设备', keepAlive: false } },
      // { path: '/Purchase', name: 'Purchase', component: () => import(/* webpackChunkName: "content" */ '../views/Index/modules/Purchase.vue'), meta: { title: '采购', keepAlive: false } },
      { path: '/User', name: 'User', component: () => import(/* webpackChunkName: "content" */ '../views/Index/modules/User.vue'), meta: { title: '我的', keepAlive: true } }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

router.beforeEach((to, from, next) => {
  window.document.title = to.meta.title
  const Flag = localStorage.getItem('FLAG')
  if (to.path === '/Pay' && Flag !== 'true') {
    next('/')
  }
  if (to.path === '/Mobile/Recharge' && !to.params.iccid) {
    Toast('请先输入卡号')
    next('/')
  }
  next()
})

router.afterEach((to, from) => {
  window.scrollTo(0, 0)
})

export default router
